import Icon from '../components/Icon.vue'

Icon.register({"dashcube":{"width":1536,"height":1792,"paths":[{"d":"M0 680q0-131 91.5-226.5t222.5-95.5h742l352-358v1470q0 132-91.5 227t-222.5 95h-780q-131 0-222.5-95t-91.5-227v-790zM1232 1434l-176-180v-425q0-46-32-79t-78-33h-484q-46 0-78 33t-32 79v492q0 46 32.5 79.5t77.5 33.5h770z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dashcube.js
// module id = 857
// module chunks = 0